import { Node, Transforms } from 'slate';
import { getNestedList, getPrevSibling } from "../lib/index.js";
import { moveListItemsToAnotherList, moveListToListItem } from "../transformations/index.js";

/**
 * If there is a nested "list" inside a "list-item" without a "list-item-text"
 * unwrap that nested "list" and try to nest it in previous sibling "list-item".
 */
export function normalizeOrphanNestedList(editor, _ref) {
  var [node, path] = _ref;

  if (!editor.isListItemNode(node)) {
    // This function does not know how to normalize other nodes.
    return false;
  }

  var children = Array.from(Node.children(editor, path));

  if (children.length !== 1) {
    return false;
  }

  var [list] = children;
  var [listNode, listPath] = list;

  if (!editor.isListNode(listNode)) {
    // If the first child is not a "list", then this fix does not apply.
    return false;
  }

  var previousListItem = getPrevSibling(editor, path);

  if (previousListItem) {
    var [, previousListItemPath] = previousListItem;
    var previousListItemNestedList = getNestedList(editor, previousListItemPath);

    if (previousListItemNestedList) {
      moveListItemsToAnotherList(editor, {
        at: list,
        to: previousListItemNestedList
      });
    } else {
      moveListToListItem(editor, {
        at: list,
        to: previousListItem
      });
    } // Remove now empty "list-item".


    Transforms.removeNodes(editor, {
      at: path
    });
  } else {
    // If there's no previous "list-item" to move nested "list" into, just lift it up.
    Transforms.unwrapNodes(editor, {
      at: listPath
    });
    Transforms.unwrapNodes(editor, {
      at: path
    });
  }

  return true;
}